/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pageSquad.vue?vue&type=template&id=682c973d&scoped=true"
import script from "./pageSquad.vue?vue&type=script&lang=js"
export * from "./pageSquad.vue?vue&type=script&lang=js"
import style0 from "./pageSquad.vue?vue&type=style&index=0&id=682c973d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682c973d",
  null
  
)

export default component.exports